import { hash32 } from '@toggle/helpers';

const LENS_COLORS = [
  'var(--chart-1, #3f8cff)',
  'var(--chart-2, #38a169)',
  'var(--chart-3, #d69e2e)',
  'var(--chart-4, #d53f8c)',
  'var(--chart-5, #805ad5)',
  'var(--chart-6, #319795)',
];

export const getLensColorVar = (lens: string): string => {
  const index = parseInt(hash32(lens), 16) % LENS_COLORS.length;

  return LENS_COLORS[index];
};
